import ConfigurationAdapter from '../../../../config/ConfigurationAdapter';
import { credentialsHandler } from '../../../Shared/Domain/credentialsHandler';
import APIv4WishlistRepository from '../../Infrastructure/APIv4WishlistRepository';
export class UpdateWishlistUseCase {
  constructor(context) {
    this.context = context;
    const v4Context = ConfigurationAdapter.getV4Context(context);
    this.wishlistRepository = new APIv4WishlistRepository(v4Context, context.drivers.httpClient);
  }
  execute(input) {
    return credentialsHandler(this.context, credentials => {
      return this.wishlistRepository.update(input, credentials);
    });
  }
}
